import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { format } from 'date-fns';
import { PickerInput } from '~/components';
import { PickerInputTypeEnum } from '~/components/PickerInput';
import { MAX_MESSAGE_LENGTH } from '~/validation/noticeBannerSchema';

interface NoticeBannerFormProps {
  isEdit?: boolean;
}

const NoticeBannerForm: FC<NoticeBannerFormProps> = ({ isEdit }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const today = format(new Date(), "yyyy-MM-dd'T'HH:mm");

  return (
    <Grid container size={12} spacing={6} pb={2} px={3}>
      <Grid size={12}>
        <FormControlLabel
          label="BANNER MESSAGE"
          required
          control={
            <TextField
              {...register('message')}
              multiline
              minRows={2}
              maxRows={6}
              error={!!errors.message}
              helperText={(errors.message?.message as string) || `Max ${MAX_MESSAGE_LENGTH} characters`}
              slotProps={{ htmlInput: { maxLength: MAX_MESSAGE_LENGTH } }}
            />
          }
        />
      </Grid>
      <Grid container size={12} spacing={2} sx={{ backgroundColor: '#F5F5F5', p: 3, borderRadius: 1 }}>
        <Grid size={12}>
          <Typography variant="body2" color="#170F5F" component="div">
            {'Schedule the Banner'.toUpperCase()}
          </Typography>
          <Typography variant="bodyDefault">Leave the below fields blank to start immediately.</Typography>
        </Grid>
        <Grid size={6}>
          <Controller
            name="start_datetime"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                label="START DATE TIME"
                control={
                  <PickerInput
                    error={!!errors.start_datetime}
                    helperText={errors.start_datetime?.message as string}
                    type={PickerInputTypeEnum.DATETIME_LOCAL}
                    slotProps={!isEdit ? { htmlInput: { min: today } } : undefined}
                    {...field}
                  />
                }
              />
            )}
          />
        </Grid>
        <Grid size={6}>
          <Controller
            name="end_datetime"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                label="END DATE TIME"
                control={
                  <PickerInput
                    error={!!errors.end_datetime}
                    helperText={errors.end_datetime?.message as string}
                    type={PickerInputTypeEnum.DATETIME_LOCAL}
                    slotProps={!isEdit ? { htmlInput: { min: today } } : undefined}
                    {...field}
                  />
                }
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NoticeBannerForm;
